// extracted by mini-css-extract-plugin
export default {"underline":"Underline_underline__PqaK7"};